import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatDate, formatMoney, getInlineLoader } from "../Helpers";
import {
  STR_CHANGE_PHONE_NUMBER,
  STR_CONSULTATION_FEE_PAYMENTS,
  STR_DEBTS,
  STR_CHARITY,
  STR_EXPENSES,
  STR_INCOME,
  STR_INSURANCE,
  STR_INVESTMENTS,
  STR_PAYMENT_SETTINGS,
  STR_PERSONAL_SETTINGS,
  STR_SAVINGS,
  STR_SUBSCRIPTION_FEE_PAYMENTS,
  STR_UPDATE_PERSONAL_INFO,
  STR_UPDATE_USERNAME,
  STR_VIEW_MORE,
  STR_UTT_CALCULATOR,
  STR_LOAN_CALCULATOR,
  STR_BOND_CALCULATOR,
  STR_LEARN_MORE,
  STR_CALCULATORS,
  STR_UTT_MONTHLY_INVESTMENT_CALC,
  STR_UTT_SINGLE_SUM_INVESTMENT_CALC,
  STR_CONTACT_US,
	STR_WHATSAPP_SETUP,
	STR_WHATSAPP_QR_HELPER,
	STR_WHATSAPP_QR_LAST_UPDATED,
	STR_WHATSAPP_BOT_STATUS,
	STR_WHATSAPP_LOGOUT,
	STR_SUCCESS,
	STR_INITIALIZE_WHATSAPP
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdCall, MdCheckCircle, MdEmail, MdInfoOutline, MdLogout, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdRefresh, MdWhatsapp } from 'react-icons/md';
import { GiBrain, GiPayMoney } from "react-icons/gi";
import { TbCalculator, TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import { PiStudent } from "react-icons/pi";
import MobileInterface from "../MobileInterface";
import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { QRCodeSVG } from "qrcode.react";
import { IoMdCloseCircle } from "react-icons/io";

export default function ContactUs(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const intervalRef = useRef(null);

  async function init() {
    //run initializations here
    setReady(false);
    await appContext.getCurrentUserData();
    setReady(true);
  }

	async function whatsAppLogOut() {
		setLoading(true);
		appContext.tellWarning("Logging you out from whatsapp may take some time, please wait...")
		await callApi('whatsapp-logout', { }).then(async response => {
			if(response.status === 1) {
				appContext.tellMessage(STR_SUCCESS[appContext.language]);
				await appContext.getCurrentUserData();
			} else {
				appContext.tellError(response.msg);
			}
		})
		setLoading(false);
	}

	async function initializeWhatsApp() {
		setLoading(true);
		appContext.tellWarning("Initializing whatsapp may take some time, please wait...")
		await callApi('initialize-whatsapp', { }).then(async response => {
			if(response.status === 1) {
				appContext.tellMessage(STR_SUCCESS[appContext.language]);
				await appContext.getCurrentUserData();
			} else {
				appContext.tellError(response.msg);
			}
		})
		setLoading(false);
	}


  useEffect(() => {
    init();

		intervalRef.current = setInterval(() => {
			appContext.getCurrentUserData();
		}, 1000 * 60 * 0.2) //refresh after 1min

		return () => {
			if(intervalRef.current) {
				clearInterval(intervalRef.current);
			}
		}
  }, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

  if (ready) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
        }}
        className="mNoScrollBar"
      >
        <div className="container">

          <div className="row">

            <div className="col-md-12">
              <div className="row" style={{ marginTop: "10px", marginBottom: "30px", }}>

                <div className="col-md-12">
                  <h6
                    style={{
                      fontSize: "28px",
                    }}
                    className="font-light"
                  >
                    {STR_WHATSAPP_SETUP[appContext.language]}
                  </h6>
                </div>

								<div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div className="card">

										<div className="card-body text-center">
											<h6
												style={{
													fontSize: "14px"
												}}
												className="mt-4 font-semi-bold text-muted"
											>
												{STR_WHATSAPP_BOT_STATUS[appContext.language]}
											</h6>
											<h6
												style={{
													fontSize: "24px"
												}}
												className="mb-4 font-bold"
											>
												{
													(appContext.currentUserData.whatsAppBotStatus === 'ready' || appContext.currentUserData.whatsAppBotStatus === 'CONNECTED') ?
													
													<span
														className="text-secondary"
													>
														<MdCheckCircle size={48}/>
														<br/>
														{appContext.currentUserData.whatsAppBotStatus}
													</span>
													:
													<span
														className="text-danger"
													>
														<IoMdCloseCircle size={48}/>
														<br/>
														{appContext.currentUserData.whatsAppBotStatus}
													</span>
												}
											</h6>

											
										</div>

									</div>
                </div>

								{
									(appContext.currentUserData.whatsAppBotStatus === 'ready' || appContext.currentUserData.whatsAppBotStatus === 'CONNECTED') ?
									<div
										className="col-12 mt-2 mb-2"
									>
										<div className="card">
											<div className="card-body">
												<div className="row">
													<div className="col-md-3 col-6 text-center">
														<div
															onClick={() => {
																appContext.activateDialog({
																	message: STR_WHATSAPP_LOGOUT[appContext.language],
																	onConfirm: whatsAppLogOut,
																})
															}}
															style={{
																width: "100%",
																padding: "5px",
																borderRadius: "10px",
																cursor: "pointer",
															}}
															className="bg-background"
														>
															<MdLogout size={36}/>
															<h6
																className="font-semi-bold"
																style={{
																	fontSize: "12px"
																}}
															>
																{STR_WHATSAPP_LOGOUT[appContext.language]}
															</h6>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									:
									<div
										className="col-12 mt-2 mb-2"
									>
										<div className="card">
											<div className="card-body">
												<div className="row">
													<div className="col-md-3 col-6 text-center">
														<div
															onClick={() => {
																appContext.activateDialog({
																	message: STR_INITIALIZE_WHATSAPP[appContext.language],
																	onConfirm: initializeWhatsApp,
																})
															}}
															style={{
																width: "100%",
																padding: "5px",
																borderRadius: "10px",
																cursor: "pointer",
															}}
															className="bg-background"
														>
															<MdWhatsapp size={36}/>
															<h6
																className="font-semi-bold"
																style={{
																	fontSize: "12px"
																}}
															>
																{STR_INITIALIZE_WHATSAPP[appContext.language]}
															</h6>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								}

                <div
                  className="col-12 mt-2 mb-2" style={{ height: "100%" }}
                >
                  <div className="card">
										<div className="card-body">
											<h6
												style={{
													fontSize: "18px"
												}}
												className="mt-2 mb-4 font-semi-bold text-secondary"
											>
												{STR_WHATSAPP_QR_HELPER[appContext.language]}
											</h6>

											<QRCodeSVG value={appContext.currentUserData.whatsAppQrCode} size={256}/>

											<hr/>
											<h6
												style={{
													fontSize: "16px"
												}}
											>
												<span
													className="text-muted d-block font-bold"
													style={{
														fontSize: "12px"
													}}
												>
													{STR_WHATSAPP_QR_LAST_UPDATED[appContext.language]}:
												</span>
												<span
													className="d-block"
												>
													{formatDate(appContext.currentUserData.whatsAppQrCodeLastUpdated)}
												</span>
											</h6>

											<div className="text-end mt-3 mb-2">
												<button
													className="btn bg-secondary"
													onClick={() => appContext.refresh()}
												>
													<MdRefresh size={24}/> REFRESH
												</button>
											</div>
										</div>
									</div>
                </div>

              
              </div>
            </div>



          </div>

        </div>


      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    );
  }


}